export default __webpack_public_path__ + "static/media/Img_electrical_wiring.9c603061.svg";